import type { IFeatureMap } from '../features';
import {
  affinity,
  autoSend,
  conversation,
  drip,
  emailList,
  emailListFacebook,
  facebook,
  googleAdsSmart,
  invites,
  landingPage,
  mailrailAutoSend,
  mailrailSingleSend,
  mobileGeoFenceRetargeting,
  mobileGeoFencing,
  omni,
  retargeting,
  search,
  seedSegment,
  singleSend,
  smartSend,
  trackedLink,
} from '../types/campaigns';

export const Internal: IFeatureMap = {
  data: {
    includedKnownPeople: Infinity,
    includedAnonymousPeople: Infinity,
    trackedActivities: Infinity,
    emailsSent: Infinity,
    standardAudienceData: true,
    audienceSegmentation: true,
    dataImporter: true,
    customDataFields: Infinity,
    conversionPixels: Infinity,
    implementationsPageVisible: true,
    zapier: Infinity,
    directIntegrations: Infinity,
    iMISDirectIntegration: true,
    blackbaudDirectIntegration: true,
  },
  ads: {
    [retargeting]: true,
    [mobileGeoFencing]: Infinity,
    [mobileGeoFenceRetargeting]: Infinity,
    [facebook]: true,
    [emailListFacebook]: true,
    [emailList]: Infinity,
    [search]: true,
    [seedSegment]: true,
    [affinity]: true,
    [googleAdsSmart]: true,
    [omni]: true,
  },
  email: {
    [singleSend]: true,
    [smartSend]: true,
    [autoSend]: true,
    [drip]: true,
    [mailrailSingleSend]: true,
    [mailrailAutoSend]: true,
    domainsAuthenticated: Infinity,
  },
  conversations: {
    [conversation]: true,
  },
  creatives: {
    adBannerCreator: Infinity,
  },
  invites: {
    [invites]: true,
    partnerManager: true,
    partnersPerProject: Infinity,
    partnerMarketingCollateralBuilder: true,
    partnerDashboards: Infinity,
  },
  monetization: {
    sponsoredRetargetingCampaigns: true,
    liveSponsorReports: true,
  },
  other: {
    flights: true,
    forms: true,
    [trackedLink]: true,
    [landingPage]: true,
    dedicatedIPs: Infinity,
    users: Infinity,
    childAccountsWithSwitcher: Infinity,
    childAccountSharingWithPermissionManagement: Infinity,
    customUserRolesAndPermissionsManagement: true,
  },
  trainingAndSupport: {
    liveChatSupport: true,
    dedicatedCSM: true,
    accessToHelpDeskFeathrAcademyAndFeathrLiveWebinars: true,
    dedicatedStrategicAdvisorHours: Infinity,
    livePhoneSupport: true,
    dataIntegrationServicesActiveWithLicense: true,
    proResourcesPageVisible: true,
  },
};
